(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ba]').forEach(function (fig) {
    var stage = fig.querySelector('[data-ba-stage]');
    var range = fig.querySelector('[data-ba-range]');
    var set = function (pct) {
      pct = Math.max(0, Math.min(100, pct));
      fig.style.setProperty('--pos', pct + '%');
      if (String(Math.round(pct)) !== range.value) range.value = Math.round(pct);
    };
    var fromEvent = function (e) {
      var r = stage.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    };
    var dragging = false, nudge = null;
    var touched = function () { fig.classList.add('is-touched'); fig.classList.remove('is-nudging'); if (nudge) { cancelAnimationFrame(nudge); nudge = null; } };
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      touched(); dragging = true; stage.setPointerCapture(e.pointerId); fromEvent(e); e.preventDefault();
    });
    range.addEventListener('focus', touched);
    // one-time nudge when the slider scrolls into view: glide the divider left and back so it reads as a control
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || fig.classList.contains('is-touched')) return;
        io.disconnect(); fig.classList.add('is-nudging');
        var start = parseFloat(range.value) || 50, t0 = null, D = 1600;
        var ease = function (x) { return 0.5 - 0.5 * Math.cos(Math.PI * x); };
        var step = function (ts) {
          if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / D);
          var off = k < 0.5 ? ease(k / 0.5) : ease((1 - k) / 0.5);      // out to -16% and back
          set(start - 16 * off);
          if (k < 1 && fig.classList.contains('is-nudging')) nudge = requestAnimationFrame(step); else nudge = null;
        };
        setTimeout(function () { if (!fig.classList.contains('is-touched')) nudge = requestAnimationFrame(step); }, 500);
      }, { threshold: 0.6 });
      io.observe(stage);
    }
    stage.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    var stop = function () { dragging = false; };
    stage.addEventListener('pointerup', stop); stage.addEventListener('pointercancel', stop);
    range.addEventListener('input', function () { set(parseFloat(range.value)); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Mirror the chosen configuration under the pills so the selection reads at a glance.
  (function () {
    var form = document.querySelector("form[data-product-form]");
    // Gallery: drive the scroll-snap carousel from the thumbnails with JS.
    // The anchor fallback (#pdp-slide-N) makes iOS scroll INSIDE the overflow-hidden
    // viewer as well as horizontally, shifting the slide up/right and clipping the watch.
    (function () {
      var slides = document.querySelector('.pdp-slides');
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb'));
      if (!slides || !thumbs.length) return;
      var setActive = function (i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); };
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          slides.scrollTo({ left: i * slides.clientWidth, top: 0, behavior: 'smooth' });
          setActive(i);
        });
      });
      var raf;
      slides.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(slides.scrollLeft / slides.clientWidth)); });
      }, { passive: true });
      // if the page loads with a slide hash, realign the viewer instead of leaving it offset
      if (/^#pdp-slide-\d+$/.test(location.hash)) {
        var n = parseInt(location.hash.replace('#pdp-slide-', ''), 10) - 1;
        requestAnimationFrame(function () { slides.scrollTo({ left: n * slides.clientWidth, top: 0 }); document.querySelector('.pdp-main').scrollTop = 0; setActive(n); });
      }
    })();

    // Direct-purchase variants (for example gift-card denominations) update the displayed price.
    var variantSelect = form && form.querySelector('select[name="id"]');
    if (variantSelect) variantSelect.addEventListener('change', function () {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var price = document.querySelector('[data-price]');
      if (price && selected) price.textContent = selected.getAttribute('data-display-price');
    });
    var summary = document.querySelector("[data-config-summary]");
    if (!form || !summary) return;
    function update() {
      var parts = [];
      form.querySelectorAll('.cfg-opts input[type="radio"]:checked').forEach(function (el) { parts.push(el.value); });
      // multi-select groups: join picks into the hidden line-item property
      form.querySelectorAll('[data-multi-target]').forEach(function (hidden) {
        var picks = [];
        form.querySelectorAll('input[data-multi="' + hidden.getAttribute('data-multi-target') + '"]:checked').forEach(function (el) { picks.push(el.value); });
        hidden.value = picks.join(', ');
        if (picks.length) parts.push(picks.join(' + '));
      });
      if (parts.length) {
        summary.textContent = "Your configuration: " + parts.join(" · ");
        summary.removeAttribute("hidden");
      }
    }
    // ---- option rules and price add-ons (see snippets/pdp-option.liquid for the [tag] syntax) ----
    var moneyFmt = form.getAttribute('data-money-format') || ('$' + '\x7b\x7bamount\x7d\x7d');
    var basePrice = parseInt(form.getAttribute('data-base-price') || '0', 10), deposit = parseInt(form.getAttribute('data-deposit') || '0', 10);
    function money(cents) {
      var n = cents / 100, s;
      if (/amount_no_decimals/.test(moneyFmt)) s = Math.round(n).toLocaleString('en-CA');
      else if (/amount_with_comma_separator/.test(moneyFmt)) s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      else s = n.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFmt.replace(/\x7b\x7b\s*amount[a-z_]*\s*\x7d\x7d/, s).replace(/<[^>]+>/g, '');
    }
    function picks(group) {
      var out = [];
      form.querySelectorAll('[data-cfg-group="' + group + '"] input:checked').forEach(function (i) { out.push(i.value.toLowerCase()); });
      return out;
    }
    function hit(group, terms) {
      var vals = picks(group);
      return terms.some(function (t) { t = t.trim().toLowerCase(); return t && vals.some(function (v) { return v.indexOf(t) !== -1; }); });
    }
    function evalRules() {
      var changed = false;
      form.querySelectorAll('.cfg-opt').forEach(function (lab) {
        var input = lab.querySelector('input'), why = lab.querySelector('[data-why]'), ok = true, reason = '';
        (lab.getAttribute('data-rules') || '').split(';').forEach(function (rule) {
          var m = rule.match(/^\s*(only|not|needs)\s+([^:]+):\s*(.+)$/i); if (!m || !ok) return;
          var kind = m[1].toLowerCase(), group = m[2].trim(), terms = m[3].split(','), h = hit(group, terms);
          if (kind === 'only' && !h) { ok = false; reason = 'Only with ' + terms.map(function (t) { return t.trim(); }).join(' or ') + ' ' + group.toLowerCase(); }
          if (kind === 'not' && h) { ok = false; reason = 'Not with a ' + terms.map(function (t) { return t.trim(); }).join(' or ') + ' ' + group.toLowerCase(); }
          if (kind === 'needs' && !h) { ok = false; reason = 'Needs ' + terms.map(function (t) { return t.trim(); }).join(' + '); }
        });
        if (/custom date disc/i.test(input.value) && !hit('Complication', ['NH35', 'NH36', 'NH34', '6R35'])) { ok = false; reason = 'Requires a movement with a date display'; }
        if (/custom day/i.test(input.value) && !hit('Complication', ['NH36'])) { ok = false; reason = 'Requires the NH36 day-and-date movement'; }
        input.disabled = !ok; lab.classList.toggle('is-off', !ok);
        if (why) { why.textContent = ok ? '' : reason; why.hidden = ok; }
        if (!ok && input.checked) {
          input.checked = false; changed = true;
          if (input.type === 'radio') { var alt = form.querySelector('[data-cfg-group="' + lab.closest('[data-cfg-group]').getAttribute('data-cfg-group') + '"] input:not(:disabled)'); if (alt) alt.checked = true; }
        }
      });
      return changed;
    }
    function price() {
      var total = basePrice;
      form.querySelectorAll('.cfg-opts input:checked[data-delta-cents]').forEach(function (i) { total += parseInt(i.getAttribute('data-delta-cents'), 10) || 0; });
      var est = form.querySelector('input[name="properties[Estimated total]"]'); if (est) est.value = money(total) + ' ' + form.getAttribute('data-currency');
      document.querySelectorAll('[data-price], [data-est]').forEach(function (el) { el.textContent = money(total); });
      var bal = document.querySelector('[data-balance]'); if (bal) bal.textContent = money(Math.max(total - deposit, 0));
    }
    function refresh() { for (var i = 0; i < 3 && evalRules(); i++) {} update(); price(); }
    var handle = form.getAttribute('data-build-handle');
    var presets = {
      'abyss-professional': { 'Strap': ['FKM rubber'], 'Optional extras': ['Premium ratcheting clasp', 'Custom date disc', 'Sapphire caseback', 'Decorated rotor'] },
      'blk-carbon-series': { 'Strap': ['FKM rubber'], 'Optional extras': ['Premium ratcheting clasp', 'Custom date disc', 'Decorated rotor'] },
      'sam-sktl-series': { 'Case finish': ['Grade 5 titanium'], 'Bezel': ['Coloured steel'], 'Strap': ['FKM rubber'] },
      'mosaic-pearlmaster': { 'Strap': ['Premium 316L SS bracelet'] },
      'carbon-case-series': { 'Strap': ['20mm forged carbon bracelet'] }
    };
    Object.keys(presets[handle] || {}).forEach(function (group) {
      form.querySelectorAll('[data-cfg-group="' + group + '"] input:not([type="hidden"])').forEach(function (input) {
        input.checked = presets[handle][group].some(function (prefix) { return input.value.indexOf(prefix) === 0; });
      });
    });
    if (handle === 'blk-carbon-series') form.querySelectorAll('[data-cfg-group="Optional extras"] .cfg-opt').forEach(function (lab) {
      if (/^Decorated rotor/.test(lab.querySelector('input').value)) lab.removeAttribute('data-rules');
    });
    form.addEventListener("change", refresh);
    refresh();
  })();

  // Sticky purchase bar: show while the in-page buy button is out of view.
  (function () {
    var bar = document.querySelector("[data-stickybar]");
    var buy = document.querySelector("[data-buy-area]");
    if (!bar || !buy || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible) { bar.setAttribute("hidden", ""); } else { bar.removeAttribute("hidden"); }
    }, { rootMargin: "-60px 0px 0px 0px" });
    io.observe(buy);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["platform-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-clamp-toggle]').forEach(function (btn) {
    var body = btn.previousElementSibling;
    btn.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
    btn.setAttribute('data-more', btn.textContent); btn.setAttribute('data-less', btn.getAttribute('data-less-label') || 'Show less');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-mentions"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rail = document.querySelector('[data-proof-rail]'); var nav = document.querySelector('[data-proof-nav]');
  if (!rail || !nav) return;
  var cards = Array.prototype.slice.call(rail.children); if (cards.length < 2) return;
  var prev = nav.querySelector('[data-proof-prev]'), next = nav.querySelector('[data-proof-next]'), count = nav.querySelector('[data-proof-count]');
  var mq = window.matchMedia('(max-width: 767px)');
  var index = function () { var x = rail.scrollLeft, best = 0, d = Infinity; cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - rail.offsetLeft - x); if (dd < d) { d = dd; best = i; } }); return best; };
  var sync = function () { var i = index(); count.textContent = (i + 1) + ' / ' + cards.length; prev.disabled = i === 0; next.disabled = i === cards.length - 1; };
  var go = function (i) { i = Math.max(0, Math.min(cards.length - 1, i)); var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; rail.scrollTo({ left: cards[i].offsetLeft - rail.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); };
  prev.addEventListener('click', function () { go(index() - 1); }); next.addEventListener('click', function () { go(index() + 1); });
  var raf; rail.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
  rail.addEventListener('focusin', function (e) { var card = e.target.closest('.proof-card'); if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
  var apply = function () { if (mq.matches) { nav.removeAttribute('hidden'); sync(); } else { nav.setAttribute('hidden', ''); } };
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply); apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-sticky-cta]'); if (!bar) return;
  var hero = document.querySelector('[data-sticky-trigger]') || document.querySelector('.hero-cta') || document.querySelector('.hero') || document.querySelector('.jumpnav');
  var enders = document.querySelectorAll('.band, footer'); if (!hero) return;
  var heroGone = false, endVisible = false;
  var apply = function () { var on = heroGone && !endVisible && window.matchMedia('(max-width: 989px)').matches; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); };
  new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; apply(); }).observe(hero);
  var endIO = new IntersectionObserver(function (es) { endVisible = es.some(function (e) { return e.isIntersecting; }) || Array.prototype.some.call(enders, function (el) { var r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; }); apply(); }, { threshold: 0 });
  enders.forEach(function (el) { endIO.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
